import {
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-healthpicks-password-input',
  templateUrl: './healthpicks-password-input.component.html',
  styleUrls: ['../style/global.css', './healthpicks-password-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => HealthpicksPasswordInputComponent),
    },
  ],
})
export class HealthpicksPasswordInputComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() name = '';

  isShow = false;

  get inputType(): string {
    return this.isShow ? 'text' : 'password';
  }

  onToggleReveal(): void {
    this.isShow = !this.isShow;
  }

  // --- ControlValueAccessor ---
  private _value = '';
  private onChangeCallback: (_: any) => void = () => {};
  private onTouchedCallback: () => void = () => {};

  get value(): string {
    return this._value;
  }

  writeValue(obj: any): void {
    this._value = obj == null ? '' : String(obj);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(_isDisabled: boolean): void {}

  onInput(ev: Event): void {
    this._value = (ev.target as HTMLInputElement).value;
    this.onChangeCallback(this._value);
  }

  onBlur(): void {
    this.onTouchedCallback();
  }
}
